<div class="c-routes__item" [class.is-active]="showing()"
    [class.context:current]="current() || portCall()?.status === voyagePortCallStates.CURRENT"
    [class.context:warning]="portCall()?.status === voyagePortCallStates.TO_BE_CONFIRMED"
    [class.context:neutral]="portCall()?.status === voyagePortCallStates.PENDING"
    [class.context:success]="portCall()?.status === voyagePortCallStates.COMPLETED">

    <!-- ! Route Card: Start -->
    <div class="c-route-card u-card" (click)="onChangeAsActive()">

        <span class="c-routes__icon fa" [class.fa-location-pin]="current()" [class.fa-arrow-right]="next()"
            [class.fa-calendar]="!next() && portCall()?.status === voyagePortCallStates.PENDING"
            [class.fa-circle-question]="portCall()?.status === voyagePortCallStates.TO_BE_CONFIRMED"
            [class.fa-location-dot]="portCall()?.status === voyagePortCallStates.CURRENT"
            [class.fa-check]="portCall()?.status === voyagePortCallStates.COMPLETED"></span>

        <div class="c-route-card__content">

            <div class="c-routes__title" [title]="portTitle()">{{ portTitle() }}</div>
            <div class="c-routes-card__dates c-bulleted-text">
                @if(portCall()?.actualArrival){
                <span>{{ 'voyage.ata' | translate }}: {{ portCall()?.actualArrival | date:'dd/MM/yyyy' }}</span>
                } @else if(portCall()?.estimatedArrival){
                <span>{{ 'voyage.eta' | translate }}: {{ portCall()?.estimatedArrival | date:'dd/MM/yyyy' }}</span>
                } @else {
                <span>{{ 'voyage.eta' | translate }}: {{ 'common.na' | translate }}</span>
                }

                @if(portCall()?.actualDeparture){
                <span>{{ 'voyage.atd' | translate }}: {{ portCall()?.actualDeparture | date:'dd/MM/yyyy' }}</span>
                } @else if(portCall()?.estimatedDeparture){
                <span>{{ 'voyage.etd' | translate }}: {{ portCall()?.estimatedDeparture | date:'dd/MM/yyyy' }}</span>
                } @else {
                <span>{{ 'voyage.etd' | translate }}: {{ 'common.na' | translate }}</span>
                }
            </div>

            <div class="c-routes-card__meta">
                <span class="c-routes-card__distance">
                    <span class="c-routes-card__distance-icon fa-solid fa-route" aria-hidden="true"></span>
                    <span>{{ (portCall()?.nauticalMileDistance ?? 0).toFixed(2) }} NM</span>
                </span>

                @if(overtimeLevel()){
                <span class="c-tag" [class.context:warning]="overtimeLevel() === portOvertimeLevel.OT1"
                    [class.context:error]="overtimeLevel() === portOvertimeLevel.OT2" [title]="overtimeTooltip()"
                    [attr.aria-label]="overtimeTooltip()" tabindex="0">{{ 'voyage.overtimeLevel.' + overtimeLevel() | translate }}</span>
                }
                @if(estimatedPdaCost()){
                <span class="c-tag" [title]="'voyage.pdaEstimatedCost' | translate">
                    ${{ estimatedPdaCost()!.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </span>
                }
            </div>

            <div class="c-routes-card__activities">
                @if(portCall()?.callType == portActivityTypes.LOADING || portCall()?.callType ==
                portActivityTypes.BOTH || portCall()?.callType == portActivityTypes.ALL){
                <div class="c-routes-card__activity fa-solid fa-box-arrow-down-arrow-up"
                    [title]="'portActivityTypes.loading' | translate">
                </div>
                }

                @if(portCall()?.callType == portActivityTypes.DISCHARGE || portCall()?.callType ==
                portActivityTypes.BOTH || portCall()?.callType == portActivityTypes.ALL){
                <div class="c-routes-card__activity fa-solid fa-box-arrow-down"
                    [title]="'portActivityTypes.discharge' | translate">
                </div>
                }

                @if(portCall()?.callType == portActivityTypes.TECHNICAL){
                <div class="c-routes-card__activity fa-solid fa-wrench"
                    [title]="'portActivityTypes.technical' | translate">
                </div>
                }

                @if(portCall()?.callType == portActivityTypes.BUNKER_CALL || portCall()?.callType == portActivityTypes.ALL){
                <div class="c-routes-card__activity fa-solid fa-gas-pump"
                    [title]="'portActivityTypes.bunker_call' | translate">
                </div>
                }

                @if(portCall()?.callType == portActivityTypes.SERVICE_CALL){
                <div class="c-routes-card__activity fa-solid fa-clipboard-list"
                    [title]="'portActivityTypes.service_call' | translate">
                </div>
                }

                @if(portCall()?.isTransshipmentHub){
                <div class="c-routes-card__activity fa-solid fa-shuffle"
                    [title]="'voyage.transshipmentHub' | translate">
                </div>
                }
                <!-- <div class="c-routes-card__activity fa fa-users" title="Crew"></div> -->
                <!-- <div class="c-routes-card__activity fa-solid fa-box-arrow-down-arrow-up" title="Discharging"></div> -->
                <!-- <div class="c-routes-card__activity fa fa-gas-pump" title="Refuelling"></div> -->
                <!-- <div class="c-routes-card__activity fa fa-wrench" title="Maintainance"></div> -->
                <!-- <div class="c-routes-card__activity fa-solid fa-salad" title="Supply"></div> -->
                <!-- <div class="c-routes-card__activity fa fa-droplet" title="Water"></div> -->
            </div> <!-- .c-routes-card__activities -->

        </div> <!-- .c-route-card__content -->
        <button type="button" class="c-route-card__options c-icon-btn" (click)="onMoreOptions(portCall()?.id, $event)"
            [id]="'dropdown-trigger-' + portCall()?.id">
            <span class="icon-more"></span>
        </button>
        <core-dropdown [rowId]="portCall()?.id" [row]="portCall()"
            [triggerElementId]="'dropdown-trigger-' + portCall()?.id" [extraDefaultActions]="extraDefaultActions()"
            [extraCustomActions]="$any(extraCustomActions())"
            (actionTriggered)="triggerAction($event.action, $event.row)"
            (customActionTriggered)="triggerAction($event.action, $event.row)" #dropdown>
        </core-dropdown>

    </div> <!-- .c-route-card -->
    <!-- ! Route Card: End -->

    <!-- ! Route Btn: Start -->
    <button type="button" tabindex="-1" class="c-route-xs" (click)="onChangeAsActive()">
        <span class="c-routes__icon fa" [class.fa-calendar]="portCall()?.status === voyagePortCallStates.PENDING"
            [class.fa-check]="portCall()?.status === voyagePortCallStates.COMPLETED"></span>
        <span class="c-routes__title" [title]="portTitle()">{{ portTitle() }}</span>
    </button>
    <!-- ! Route Btn: End -->

</div> <!-- .c-routes__item -->
